import React from 'react';
import {Provider} from 'react-redux';
import {AuthProvider} from 'react-oidc-context';
import type {Store} from 'redux';
import {PersistGate} from 'redux-persist/integration/react';
import type {Persistor} from 'redux-persist/es/types';
import {SchemaDataProvider} from 'schema/contexts';
import {authProviderProps} from '../authProviderProps';
import {AppRoutes} from './AppRoutes';
import {AuthGate} from './AuthGate';
import {ThemedApp} from './ThemedApp';
import {appSchemaDataAccess} from './schemaDataAccess';

type Props = {
  store: Store;
  persistor: Persistor;
};

export const AppContainer: React.FC<Props> = ({store, persistor}) => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <SchemaDataProvider value={appSchemaDataAccess}>
          <ThemedApp>
            <AuthProvider {...authProviderProps}>
              <AuthGate>
                <AppRoutes />
              </AuthGate>
            </AuthProvider>
          </ThemedApp>
        </SchemaDataProvider>
      </PersistGate>
    </Provider>
  );
};
